// hooks/useCreditManagement.ts
import { useCallback, useEffect, useState } from "react";
import { remainingCreditsApi } from "../utils/firebaseUtils";
import { CREDIT_REFRESH_INTERVAL } from "../config";
import { storage as localStorage } from "../utils/storage";

const useCreditManagement = (
  setRemainingCredits: React.Dispatch<React.SetStateAction<number>>,
  setNoCredits: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [loading, setLoading] = useState(true);

  const fetchTotals = useCallback(async () => {
    setLoading(true);
    const uid = await localStorage.get("id");
    if (uid) {
      try {
        const remaining = await remainingCreditsApi(uid);
        setRemainingCredits(remaining);

        if (remaining <= 0) {
          setNoCredits(true);
        } else {
          setNoCredits(false);
        }
      } catch (error) {
        console.error("Error fetching remaining credits:", error);
      }
    } else {
      console.log("No user is logged in.");
    }
    setLoading(false);
  }, [setNoCredits, setRemainingCredits]);

  // Initial fetch when component mounts
  useEffect(() => {
    fetchTotals();
  }, [fetchTotals]);

  // Periodic updates
  useEffect(() => {
    const intervalId = setInterval(fetchTotals, CREDIT_REFRESH_INTERVAL);
    return () => clearInterval(intervalId);
  }, []);

  return { fetchTotals, loading };
};

export default useCreditManagement;
